import { connect } from 'react-redux'
import { RouteComponentProps } from 'react-router'
import StationUserViewPane from '../../components/station-user/view/StationUserViewPane'
import { getOrganization } from '../../state/selectors'
import { IStoreState, IStationUserSearchObject } from '../../types'
import { moveToArchive, fetchStationUser } from '../../state/actions/station-user/index'
import { recoverPassword } from 'src/state/actions/auth'
import { IStationUserViewPaneParams } from 'src/components/station-user/view/StationUserInfo'

const mapStateToProps = (state: IStoreState, ownProps: any): any => {
  const { match } = ownProps
  const stationUser = state.stationUser.items[match.params.id]
  return {
    stationUser,
    stationUserId: ownProps.match.params.id,
    routeProps: ownProps,
    zones: state.goinzones.items
  }
}

const mapDispatchToProps = (dispatch: any, props: RouteComponentProps<IStationUserViewPaneParams>) => {
  return {
    fetchStationUser: () => dispatch(fetchStationUser(props.match.params.id)),
    onArchiveClick: (stationUser: IStationUserSearchObject) => dispatch(moveToArchive(stationUser))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StationUserViewPane)



// WEBPACK FOOTER //
// ./src/containers/station-user/StationUserViewPane.ts